export default "__VITE_ASSET__DBR4Y_Jt__"